<template>
	<div class="phhonor">
		<hpheader></hpheader>
		<div class="phvir-hea">{{info.honor}}</div>
		<div class="phonor-sc">
			<el-carousel >
			    <el-carousel-item v-for="item in comhonor" :key="item">
					<img :src="item.images" />
			    </el-carousel-item>
			</el-carousel>
		</div>
		<hpfooter></hpfooter>
	</div>
</template>

<script>
	import hpheader from '../../common/hpheader.vue'
	import hpfooter from '../../common/hpfooter.vue'
	import {session} from "../../storage/storage";
	export default{
		data(){
			return{
				comhonor:[]
			}
		},
		created() {
			window.scrollTo(0,0);
			this.ress()
			this.pccompanyhonor();
			this.pageParam();
			if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
				console.log('手机手机21321321')
				this.$router.push({path:'./pcabout',query:{e:3}})
			}
		},
		components:{
			hpfooter,
			hpheader
		},
		methods:{
			pageParam(){
				let lang =  session.get("lang");
				if (lang === "cn"){
				this.info = {
					'about': "关于啄木鸟",
					'around': "公司环境",
					'honor': '公司荣誉',
					'news' : '新闻中心',
					'course' : '公司历程',
					'more' : "显示更多",
					'special': '专题',
				}
				}else{
				this.info = {
					'about': "About woodpecker",
					'around': "Company environment",
					'honor': 'Company honor',
					'news' : 'News Center',
					'course' : 'Company history',
					'more' : "More",
					'special': 'Special',
				}
		
				}
			},
			pccompanyhonor(){
				let data={
				lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
				channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
				mold:'h5',
		
				}
				this.$api.get_company_honor(data).then((res) => {
				this.comhonor=res.data
				console.log(this.comhonor)
				});
			},
			ress(){
				var html = document.documentElement; //获取根元素
				var designWidth = 750; //设计稿宽度
				//html.clientWidth 视口宽度
				html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
			},
		}
	}
</script>

<style>
	body{
		margin: 0;
		padding: 0;
	}
	.phhonor{
		background: #FFF;
		padding-top: 0.88rem;
	}
	.phhonor-hea{
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 7.5rem;
		height: 0.88rem;
		background: #FFFFFF;
	}
	.phhonorhea-left{
		margin-left: 0.3rem;
		width: 0.97rem;
		height: 0.5rem;
	}
	.phhonorhea-left img{
		width: 100%;
		height: 100%;
	}
	.phhonorhea-right{
		margin-right: 0.3rem;
		width: 0.38rem;
		height: 0.38rem;
	}
	.phhonorhea-right img{
		width: 100%;
		height: 100%;
	}
	.phvir-hea{
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 36px;
		font-weight: 500;
		color: #5d5f5f;
		letter-spacing: 1px;
	}
	
	.el-carousel{
		height: 4.8rem;
		width: 6.8rem;
	}
	.el-carousel .el-carousel__item{
		height: 4.8rem;
		width: 6.8rem;
	}
	.el-carousel .el-carousel__item img{
		height: 4.8rem;
		width: 6.8rem;
	}
	.phonor-sc{
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 0.4rem;
		margin-bottom: 0.6rem;
	}
	.phvir-hea{
		font-size: 0.36rem;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		margin-top: 0.4rem;
	}
	 .el-carousel__indicator.is-active button{
	 	background: red;
	 }
	 
	 .el-carousel__button{
	 	width: 0.24rem;
	 	height: 0.12rem;
	 	background: #EAEAEA;
	 	border-radius: 0.06rem;
	 }
</style>
